import { CloseOutlined, CurrencyRupee } from "@mui/icons-material";
import {
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    tableCellClasses,
} from "@mui/material";

import { styled } from "@material-ui/core";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setClientCustomizedRateHistory } from "../../../redux/userManagement/userManagementSlice";
import { apiGatewayAxiosInstance } from "../../../utils/axios";
import TablePaginationShowPage from "../../../utils/tablePagination";
import { ERoles, OtherFields } from "../../../config";
// import { showSnackbar } from '../store/snackbarSlice';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontWeight: 600,
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
        padding: "10px !important",
        width: "20vw",
    },
    [`&.${tableCellClasses.body}`]: {
        padding: "10px !important",
        fontSize: 14,
    },
    [`&.${tableCellClasses.head.tr}`]: {
        backgroundColor: "#79E0EE",
        width: "45vw",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

export default function ViewHistoryOfCustomizedRates({ open, handleClose, clientData }) {
    const dispatch = useDispatch();
    const state = useSelector(state => state.userManagementSlice);
    const [totalCount, setTotalCount] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const getHistoryOfClientCustomizedRates = async (providerId, providerCode, countryCode, registryId, orgId) => {
        const response = await apiGatewayAxiosInstance.get(`/billing_management/customized-rate-card/get-provider-customized-rate-history`, {
            params: {
                providerId: providerId,
                providerCode: providerCode,
                pageSize: pageSize,
                countryCode: countryCode,
                currentPage: currentPage,
                registryId: registryId,
                orgId: orgId,
            },
        });

        dispatch(setClientCustomizedRateHistory(response.data.data.findCurrentRates));
        setTotalCount(response.data.data.totalCount);
    };

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
    };

    useEffect(() => {
        let registryIdToSend;
        let orgIdToSend;
        if (clientData.roleName === ERoles.ORG_ADMIN) {
            registryIdToSend = clientData.registryId;
            orgIdToSend = clientData.orgId;
        } else {
            registryIdToSend = clientData._id;
            orgIdToSend = "";
        }
        getHistoryOfClientCustomizedRates(
            clientData.rate.customizedRate.providerId,
            clientData.rate.customizedRate.providerCode,
            clientData.rate.countryCode,
            registryIdToSend,
            orgIdToSend,
        );
    }, [currentPage, pageSize]);

    const checkCurrentRate = (fromDate, toDate) => {
        //This function is to show current rates
        const currentDate = new Date();
        fromDate = fromDate ? new Date(fromDate) : null;
        toDate = toDate ? new Date(toDate) : null;

        // if (!isNaN(fromDate) && !isNaN(toDate)) {

        if (currentDate >= fromDate && currentDate <= toDate) {
            // Condition for Future present rates
            return "CURRENT";
        } else if (!isNaN(fromDate) && (!toDate || isNaN(toDate)) && currentDate >= fromDate) {
            // Condition for current rates
            return "CURRENT";
        } else {
            return null;
        }
        // } else {
        //     return null;
        // }
    };

    return (
        <Dialog open={open} onClose={handleClose} sx={{ padding: "1rem", width: "85%", marginLeft: "15%" }} maxWidth={"large"}>
            {/* <form onSubmit={formik.handleSubmit}> */}
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Grid display={"flex"}>
                    <Typography variant='h5'>
                        {/* <b>History of Customize Rates for</b> */}
                        <b>
                            {clientData.roleName === (ERoles.SUPER_ADMIN || ERoles.RESELLER_ADMIN)
                                ? "History of Customize Rates for"
                                : "History of Applicable Rates for"}
                        </b>
                    </Typography>
                    <Typography variant='h5' className='text-primary'>
                        &nbsp;<b> {clientData?.resellerName ? clientData.resellerName : clientData?.orgDetails?.orgName}</b>
                    </Typography>
                </Grid>
                <IconButton onClick={() => handleClose()}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <Divider variant='middle' />
            <DialogContent>
                <Card className='border border-secondary-50 '>
                    <CardContent sx={{ padding: 0 }}>
                        <Grid
                            // mt={2}
                            sx={{
                                display: "flex ",
                                justifyContent: "center",
                                flexDirection: "column",
                                overflowY: "scroll !important",
                                overflowX: "hidden !important",
                            }}
                        >
                            {/* {state.controls.isUpdateUsersLoading ? ( */}
                            {/* <FetchingSpinner /> */}
                            {/* ) : ( */}
                            <>
                                {/* {state.masterRatesList && state.masterRatesList.length > 0 ? ( */}
                                <TableContainer
                                    component={Paper}
                                    className='table-container'
                                    sx={{
                                        height: "420px",
                                        overflowY: "scroll !important",
                                        overflowX: "hidden !important",
                                        width: "auto !important",
                                    }}
                                >
                                    <Table className='center' aria-label='table with sticky header' stickyHeader>
                                        <TableHead className='p-3 mb-2 row'>
                                            <TableRow>
                                                <StyledTableCell className='col-1 tableHeaderFont'>Sr No.</StyledTableCell>
                                                <StyledTableCell className='col-1 tableHeaderFont'>Provider Code</StyledTableCell>
                                                {/* <StyledTableCell className='col-1 tableHeaderFont'>Short Code</StyledTableCell> */}
                                                <StyledTableCell className='col-1 tableHeaderFont'>Text Message Rate (INR)</StyledTableCell>
                                                <StyledTableCell className='col-1 tableHeaderFont'>Multi Media Message Rate (INR)</StyledTableCell>
                                                <StyledTableCell className='col-1 tableHeaderFont'>
                                                    A2P Session Conversation Rate (INR)
                                                </StyledTableCell>
                                                <StyledTableCell className='col-1 tableHeaderFont'>Feedback Rate (INR)</StyledTableCell>
                                                {clientData?.rate &&
                                                    Object.keys(clientData?.rate?.baseRate?.otherFields).map((provider, index) => (
                                                        <StyledTableCell className='col-1 tableHeaderFont'>
                                                            {OtherFields[provider] ?? provider} (INR)
                                                        </StyledTableCell>
                                                    ))}
                                                <StyledTableCell className='col-1 tableHeaderFont'>Effective from</StyledTableCell>
                                                <StyledTableCell className='col-1 tableHeaderFont'>Effective to</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {
                                            <TableBody>
                                                {state.clientCustomizedRateHistory &&
                                                    state.clientCustomizedRateHistory.length > 0 &&
                                                    state.clientCustomizedRateHistory.map((app, index) => (
                                                        <StyledTableRow>
                                                            <StyledTableCell className='tableContentFont' align='center'>
                                                                <b>{currentPage * pageSize + index + 1}</b>
                                                            </StyledTableCell>
                                                            <StyledTableCell align='left' className='tableContentFont'>
                                                                {app.providerCode}
                                                            </StyledTableCell>
                                                            <StyledTableCell align='left' className='tableContentFont'>
                                                                <CurrencyRupee sx={{ fontSize: "14px" }} />
                                                                {app?.customizedProviderRate[app.providerCode]?.A2pMessageRate?.textMessageRate?.toFixed(4)}
                                                            </StyledTableCell>
                                                            <StyledTableCell align='left' className='tableContentFont'>
                                                                <CurrencyRupee sx={{ fontSize: "14px" }} />
                                                                {app?.customizedProviderRate[
                                                                    app.providerCode
                                                                ]?.A2pMessageRate?.multiMediaMessageRate.toFixed(4)}
                                                            </StyledTableCell>
                                                            <StyledTableCell align='left' className='tableContentFont'>
                                                                <CurrencyRupee sx={{ fontSize: "14px" }} />
                                                                {app?.customizedProviderRate[
                                                                    app.providerCode
                                                                ]?.A2pMessageRate?.A2pSessionConversationRate.toFixed(4)}
                                                            </StyledTableCell>
                                                            <StyledTableCell align='left' className='tableContentFont'>
                                                                <CurrencyRupee sx={{ fontSize: "14px" }} />

                                                                {app?.customizedProviderRate[app.providerCode]?.A2pMessageRate?.feedbackRate.toFixed(
                                                                    2,
                                                                )}
                                                            </StyledTableCell>

                                                            {app?.customizedProviderRate[app.providerCode]?.otherFields &&
                                                                Object.keys(app?.customizedProviderRate[app.providerCode]?.otherFields).map(
                                                                    (provider, index) => (
                                                                        <StyledTableCell align='left'>
                                                                            <CurrencyRupee sx={{ fontSize: "14px" }} />
                                                                            {app?.customizedProviderRate[app.providerCode]?.otherFields &&
                                                                                app?.customizedProviderRate[app.providerCode]?.otherFields[
                                                                                    provider
                                                                                ].toFixed(4)}
                                                                        </StyledTableCell>
                                                                    ),
                                                                )}

                                                            <StyledTableCell align='left' className='tableContentFont' sx={{ width: "700px" }}>
                                                                {app?.effectiveFrom
                                                                    ? (() => {
                                                                        const date = new Date(app.effectiveFrom);
                                                                        const options = {
                                                                            year: "numeric",
                                                                            month: "2-digit",
                                                                            day: "2-digit",
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                            hour12: true,
                                                                        };
                                                                        const formattedDate = date.toLocaleString("en-US", options);
                                                                        return formattedDate.replace(",", "");
                                                                    })()
                                                                    : null}
                                                            </StyledTableCell>

                                                            <StyledTableCell
                                                                align='left'
                                                                className='tableContentFont'
                                                                sx={{
                                                                    width: "700px",
                                                                    border: checkCurrentRate(app.effectiveFrom, app.effectiveTo)
                                                                        ? "2px solid green"
                                                                        : "none",
                                                                    padding: "16px",
                                                                    borderRadius: "4px",
                                                                }}
                                                            >
                                                                <Grid>
                                                                    <Typography className='tableContentFont'>
                                                                        {app?.effectiveTo
                                                                            ? (() => {
                                                                                const date = new Date(app.effectiveTo);
                                                                                const options = {
                                                                                    year: "numeric",
                                                                                    month: "2-digit",
                                                                                    day: "2-digit",
                                                                                    hour: "2-digit",
                                                                                    minute: "2-digit",
                                                                                    hour12: true,
                                                                                };
                                                                                const formattedDate = date.toLocaleString("en-US", options);
                                                                                return formattedDate.replace(",", "");
                                                                            })()
                                                                            : ""}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid>
                                                                    <Typography fontSize={"0.8rem"} fontWeight={600} color={"green"}>
                                                                        {
                                                                            // app?.effectiveFrom &&
                                                                            //     app?.effectiveTo &&
                                                                            checkCurrentRate(app.effectiveFrom, app.effectiveTo)
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                            </TableBody>
                                        }
                                    </Table>
                                </TableContainer>
                                {/* // ) : ( */}
                                {/* <NoRecords /> */}
                                {/* // )} */}
                            </>
                            {/* // )} */}
                        </Grid>

                        {totalCount > 0 && (
                            <Grid
                                className='my-2'
                                style={{
                                    zIndex: "2",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: 2,
                                }}
                            >
                                <Grid
                                    style={{
                                        marginTop: "15px",
                                        padding: 5,
                                    }}
                                >
                                    Total Master Rates: {totalCount}
                                </Grid>
                                <Grid>
                                    <TablePaginationShowPage
                                        rowsPerPageOptions={[5, 10, 25, 100]}
                                        colSpan={3}
                                        count={totalCount}
                                        rowsPerPage={pageSize}
                                        page={currentPage}
                                        slotProps={{
                                            select: {
                                                "aria-label": "Rows per page",
                                            },
                                            actions: {
                                                showFirstButton: true,
                                                showLastButton: true,
                                                slots: {
                                                    firstPageIcon: FirstPageRoundedIcon,
                                                    lastPageIcon: LastPageRoundedIcon,
                                                    nextPageIcon: ChevronRightRoundedIcon,
                                                    backPageIcon: ChevronLeftRoundedIcon,
                                                },
                                            },
                                        }}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions
                style={{
                    padding: "1rem 1.5rem",
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            ></DialogActions>
        </Dialog>
    );
}
